import settings from '../assets/settings-hamburger.svg';
import React from 'react';
import styled from 'styled-components';
import { theme } from '../style/theme';

const ButtonWrapper = styled.div<{ disable: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing[3]};
  margin: 0 ${theme.spacing[4]};
  border-radius: ${theme.borderRadius.lg};
  cursor: pointer;
  transition: all ${theme.transitions.normal};
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  visibility: ${({ disable }) => disable && 'hidden'};
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: ${theme.colors.primary.main};
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.md};
  }
  
  &:active {
    transform: translateY(0);
    background: rgba(255, 255, 255, 0.15);
  }
`;

const Img = styled.img<{ disable: boolean }>`
  height: 18px;
  width: 20px;
  filter: brightness(0) invert(1);
  transition: all ${theme.transitions.fast};
  pointer-events: none; 
  ${ButtonWrapper}:hover & {
    filter: brightness(0) invert(1);
    transform: scale(1.1);
  }
`;

const SettingsButton = ({ onClick, disable }) => {
  return (
    <ButtonWrapper
      id="settingsButton"
      disable={disable}
      onClick={onClick}
    >
      <Img
        disable={disable}
        src={settings}
        alt="Settings"
      />
    </ButtonWrapper>
  );
};

export default SettingsButton;
